<div class="generic-table-component">
  <div class="table-responsive">
    <table aria-describedby="Profiles table" class="table table-head-purple">
      <thead>
        <tr>
          <th
            *ngFor="let column of columns"
            [ngStyle]="{ 'width.%': column.width }"
          >
            {{ column.name }}
          </th>
          <th
            *ngIf="showStatus"
            class="text-center"
            [ngStyle]="{ 'padding-right.px': !actionRemove ? 20 : 0 }"
          >
            {{ lextranslate.i18n["6d397634-5494-4851-a071-db8a76573348"] }}
          </th>
          <th
            *ngIf="actionRemove"
            class="thActions"
            [ngStyle]="{ 'padding-right.px': actionRemove ? 20 : 0 }"
          >
            {{ lextranslate.i18n["e4f0c057-4cfc-4c8f-8629-0028f33e4f16"] }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of data; let i = index" style="height: 55px">
          <td *ngFor="let column of columns">
            <!-- Label default -->
            <span *ngIf="!isArr(d[column.id])" [ngClass]="column.ngClass" [class.small-text]="column.truncateLongText && isLongText(d[column.id])">{{
              d[column.id]
            }}</span>

            <!-- Foldable component -->
            <foldable-content
              *ngIf="isArr(d[column.id])"
              [items]="d[column.id] || []"
              bindLabel="name"
            >
            </foldable-content>
          </td>
          <td
            *ngIf="showStatus"
            class="text-center"
            [ngStyle]="{ 'padding-right.px': !actionRemove ? 20 : 0 }"
          >
            <abbr
              class="user-status-circle"
              [ngClass]="
                'user-status-circle--' +
                getStatusColorAndLabel(d.statusType).colorName
              "
              [title]="getStatusColorAndLabel(d.statusType).label"
            >
            </abbr>
          </td>
          <td
            *ngIf="actionRemove"
            class="thActions"
            [ngStyle]="{ 'padding-right.px': actionRemove ? 20 : 0 }"
          >
            <button
              type="button"
              [disabled]="d.disabled"
              class="btn btn-primary btn-transparent"
              style="color: #f14f4f"
              (click)="onRemove(i, d)"
            >
              <em
                style="font-size: 28px"
                class="sidebar-item-icon material-icons"
                >close</em
              >
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <div *ngIf="(data && data.length === 0) || !data" class="noContentTable">
        {{ lextranslate.i18n["4079c171-e6e1-4a9d-b741-e8fa02c8dcb7"] }}.
      </div>
    </div>
  </div>
</div>
